<template lang="pug">
div(class='relative' @mouseleave='isOpen = false')
  button(
    aria-label='Select rating'
    class='mr-2 w-full rounded-full border border-gray-light hover:border-black text-left text-sm h-9 pl-4'
    @click='isOpen = true'
  )
    span(class='flex justify-between')
      span(v-if='selectedRating === "all"' class='text-sm') Rating
      span(v-else class='flex items-center')
        span(v-for='i in 5' :key='i' class='w-[18px] h-[18px] mr-2')
          img(
            :src='i <= parseInt(selectedRating) ? "/images/star-full-bw.svg" : "/images/star-empty-bw.svg"'
            width='18'
            height='18'
            alt='star'
          )
      img(src='@/assets/arrow.svg' class='w-2 mr-3' width='12' height='12' alt='dropdown arrow')

  div(v-show='isOpen' class='absolute w-full z-10 p-3 left-0 bg-white shadow-lg')
    div(
      class='flex justify-between cursor-pointer px-2 h-9 items-center text-sm hover:bg-gray-lighter bg-gray-lighter'
      @click='selectRating("all")'
    )
      span All ratings
      img(v-if='selectedRating === "all"' src='@/assets/checkmarkThin.svg' class='w-3' width='12' height='12' alt='checkmark')
    div(
      v-for='rating in 5'
      :key='6 - rating'
      class='flex justify-between cursor-pointer px-2 h-9 items-center text-sm hover:bg-gray-lighter'
      @click='selectRating((6 - rating).toString())'
    )
      div(class='flex items-center')
        div(v-for='i in 5' :key='`${rating}-${i}`' class='w-[18px] h-[18px] mr-2')
          img(
            :src='i <= 6 - rating ? "/images/star-full-bw.svg" : "/images/star-empty-bw.svg"'
            width='18'
            height='18'
            alt='star'
          )
      img(
        v-if='selectedRating === (6 - rating).toString()'
        src='@/assets/checkmarkThin.svg'
        class='w-3'
        width='12'
        height='12'
        alt='checkmark'
      )
</template>

<script setup lang="ts">
const { selectedRating } = defineProps<{
  selectedRating: string
}>()

const emit = defineEmits(['onRatingChange'])

const isOpen = ref(false)

function selectRating(value: string) {
  isOpen.value = false
  emit('onRatingChange', value)
}
</script>
